<div class="container">
  <div class="loader-container" *ngIf="isLoading">
    <dxo-circular-loader text="Loading..."></dxo-circular-loader>
  </div>
  <ng-container *ngIf="!isLoading">
    <div id="employee-details-container">
      <dxo-card [bodyHeader]="EmployeeCardHeader" data-e2e="employee-information-header">
        <card-body>
          <div class="data-container">
            <ng-container>
              <dxo-label-value [label]="Name" [values]="[employeeInfo.fullName]" />
              <dxo-label-value [label]="Birthdate" [values]="[employeeInfo.birthdate]" />
              <dxo-label-value [label]="Gender" [values]="[employeeInfo.gender]" />
              <div class="indicator-container">
                <span class="status-indicator" [style.background-color]="employeeInfo.statusColor"></span>
                <dxo-label-value [label]="Status" [values]="[employeeInfo.status!]" />
              </div>
              <dxo-label-value [label]="Occupation" [values]="[employeeInfo.occupation]" />
              <dxo-label-value [label]="SSN" [values]="[employeeInfo.maskedssn]" />
              <dxo-label-value [label]="Salary" [values]="[employeeInfo.salary!]" />
              <dxo-label-value [label]="HireDate" [values]="[employeeInfo.hireDate]" />
              <dxo-label-value
                [label]="SmokerStatus"
                [values]="[employeeInfo.smokerStatus]"
                *ngIf="employeeInfo.smokerStatus"
              />
              <dxo-label-value
                [label]="BillDivision"
                [values]="[employeeInfo.billDivision ?? '']"
              />
            </ng-container>
          </div>
        </card-body>
      </dxo-card>
    </div>
    <div *ngFor="let item of dependentsList; index as i" id="dependent-details-container">
      <dxo-card [bodyHeader]="getDepCardTitle(i)">
        <card-body>
          <div class="data-container">
            <ng-container>
              <dxo-label-value [label]="Name" [values]="[item.fullName]" />
              <dxo-label-value [label]="Birthdate" [values]="[item.birthdate]" />
              <dxo-label-value [label]="Gender" [values]="[item.gender]" />
              <div class="indicator-container">
                <span class="status-indicator" [style.background-color]="item.statusColor"></span>
                <dxo-label-value [label]="Status" [values]="[item.status]" />
              </div>
              <dxo-label-value [label]="Relationship" [values]="[item.relationship]" />
              <dxo-label-value [label]="SmokerStatus" [values]="[item.smokerStatusString]" *ngIf="item.smokerStatus" />
              <dxo-label-value [label]="SSN" [values]="[item.maskedssn]" />
              <dxo-label-value *ngIf="item.student" [label]="Student" [values]="[item.student]" />
              <dxo-label-value *ngIf="item.disabled" [label]="Disabled" [values]="[item.disabled]" />
            </ng-container>
          </div>
        </card-body>
      </dxo-card>
    </div>
    <dxo-card [bodyHeader]="InsuranceCardHeader" data-e2e="insurance-cov-header">
      <dxo-accordion [showBottomBorder]="false" [showContent]="true" title="Life and AD&D elections">
        <accordion-content>
          <dxo-data-table [headers]="generalTableHeaders" [items]="lifeCoverageData">
            <ng-template dxoKey="description" let-item>
              <span>
                {{ item.description }}
              </span>
              <span class="row-cell">
                <dxo-button
                  *ngIf="item.dependents && item.dependents.length > 0"
                  [textButton]="true"
                  text="Covered dependents"
                  (handleClick)="openDependentsModal(item.dependents)"
                >
                </dxo-button>
              </span>
            </ng-template>
          </dxo-data-table>
        </accordion-content>
      </dxo-accordion>
      <dxo-accordion [showBottomBorder]="false" title="Disability elections">
        <accordion-content>
          <dxo-data-table [headers]="generalTableHeaders" [items]="disabilityElectionsData"></dxo-data-table>
        </accordion-content>
      </dxo-accordion>
      <dxo-accordion [showBottomBorder]="false" title="Absence and paid leave elections">
        <accordion-content>
          <dxo-data-table [headers]="absenceTableHeaders" [items]="absenceAndPaidLeaveData"></dxo-data-table>
        </accordion-content>
      </dxo-accordion>
      <dxo-modal *ngIf="showModal" [title]="ModalTitle">
        <modal-body>
          <ul>
            <li *ngFor="let item of modalList">
              {{ item }}
            </li>
          </ul>
          <dxo-button text="Close" (handleClick)="modalClose()"></dxo-button>
        </modal-body>
      </dxo-modal>
    </dxo-card>
    <div class="card-footer">
      <span></span>
      <div class="total-calc">
        <dxo-label-value [label]="TotalAmountLabel" [currency]="true" [values]="[totalAmount]"></dxo-label-value>
      </div>
    </div>
  </ng-container>
</div>
